import { render, staticRenderFns } from "./union-coop.vue?vue&type=template&id=0a0ad131"
import script from "./union-coop.vue?vue&type=script&lang=js"
export * from "./union-coop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/union-coop-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Funion-coop.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/union-coop-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Funion-coop.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,VueGlideComponent: require('/vercel/path0/components/vue-glide-component.vue').default,CtaImage: require('/vercel/path0/components/ui/cta-image.vue').default,StartTradingSteps: require('/vercel/path0/components/StartTradingSteps.vue').default})
